import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import classes from "./artistVideoCarousel.module.css";
import { getYoutubeVideoId } from "../../../utils";

const ArtistVideoCarousel = ({ videos }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!videos || videos.length === 0) {
    return (
      <div className={classes.emptyContainer}>
        <div className={classes.emptyIcon}>🎬</div>
        <p>No videos available</p>
      </div>
    );
  }

  // Function to extract YouTube video ID from URL

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === videos.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? videos.length - 1 : prevIndex - 1
    );
  };

  // Get current video's YouTube ID
  const currentVideoId = getYoutubeVideoId(
    videos[currentIndex]?.mediaLink || videos[currentIndex]
  );

  return (
    <div className={classes.videoCarouselContainer}>
      <h2 className={classes.sectionTitle}>Videos</h2>

      {/* Main Video Player */}
      <div className={classes.videoWrapper}>
        <button
          className={`${classes.carouselArrow} ${classes.left}`}
          onClick={prevSlide}
          aria-label="Previous video"
        >
          &#10094;
        </button>

        <div className={classes.videoContainer}>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              className={classes.videoFrame}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              {currentVideoId ? (
                <iframe
                  src={`https://www.youtube.com/embed/${currentVideoId}`}
                  title={`YouTube video ${currentIndex + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <div className={classes.invalidVideo}>
                  <p>Invalid YouTube URL</p>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>

        <button
          className={`${classes.carouselArrow} ${classes.right}`}
          onClick={nextSlide}
          aria-label="Next video"
        >
          &#10095;
        </button>
      </div>

      {/* Video Title and Description */}
      <div className={classes.videoInfo}>
        <h3 className={classes.videoTitle}>
          {videos[currentIndex]?.title ||
            `Performance Video ${currentIndex + 1}`}
        </h3>
        {videos[currentIndex]?.description && (
          <p className={classes.videoDescription}>
            {videos[currentIndex].description}
          </p>
        )}
      </div>

      {/* Video Thumbnails */}
      <div className={classes.videoThumbnails}>
        {videos?.map((video, index) => {
          const videoId = getYoutubeVideoId(video?.mediaLink || video);
          const thumbnailUrl = videoId
            ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
            : "/api/placeholder/120/70";

          return (
            <div
              key={index}
              className={`${classes.videoThumbnail} ${
                index === currentIndex ? classes.activeVideoThumbnail : ""
              }`}
              onClick={() => setCurrentIndex(index)}
            >
              <img src={thumbnailUrl} alt={`Video thumbnail ${index + 1}`} />
              <div className={classes.playIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ArtistVideoCarousel;
